import { Position } from "@xyflow/react";
import { MessageSquare } from "lucide-react";
import { BaseHandle } from "../../components/base-handle";
import { BaseNode, BaseNodeContent } from "../../components/base-node";
import { ContextualTipsTrigger } from "@babackapp/ui/components/contextual-tips";
import { useTranslation } from "react-i18next";

export const GORGIAS_ACTION_NODE_WIDTH = 250;
export const GORGIAS_ACTION_NODE_HEIGHT_ESTIMATION = 120;

export function GorgiasActionNodeEditor({ id }: any) {
  const { t } = useTranslation("trackoffice");

  return (
    <ContextualTipsTrigger
      tips={[
        {
          id: "workflow-node-gorgias",
          Icon: MessageSquare,
          title: t(
            "workflowsEditor.tips.workflowNodeGorgias.title",
            "This is a Gorgias ticket action node",
          ),
          description: t(
            "workflowsEditor.tips.workflowNodeGorgias.desc",
            "This node will create a support ticket in Gorgias with tracking information.",
          ),
        },
      ]}
    >
      <BaseNode nodeId={id} style={{ position: "relative" }}>
        <BaseNodeContent>
          <div className="flex flex-col gap-2 w-full">
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">
                {t("workflowsEditor.gorgiasNode.action", "Action")}
              </span>
              <span className="text-xs mt-1 font-semibold">
                {t(
                  "workflowsEditor.gorgiasNode.createTicket",
                  "Create Gorgias Ticket",
                )}
              </span>
            </div>
          </div>
          <BaseHandle type="target" position={Position.Left} />
          <BaseHandle
            type="source"
            position={Position.Right}
            style={{ top: "50%", transform: "translateY(-50%)" }}
          />
        </BaseNodeContent>
      </BaseNode>
    </ContextualTipsTrigger>
  );
}
